import { gql } from '@apollo/client/core';

/** The selection list matches the fields `TicketBlueprint.fromGql` reads exactly. */
export const TICKET_BLUEPRINT_FIELDS = gql`
  fragment TicketBlueprintFields on TicketBlueprint {
    id
    eventId
    name
    kind
    orderPriority
    allotment
    sectionId
    sellStart
    sellEnd
    description
    price
    fee
    dependencyId
    sellableThrough
    minimum
    maximum
    multiple
  }
`;

/** The selection list matches the fields `TicketHold.fromGql` reads exactly. */
export const TICKET_HOLD_FIELDS = gql`
  fragment TicketHoldFields on TicketHold {
    id
    eventId
    name
    quantity
    orderPriority
    sourceTicketId
    description
  }
`;
